<mat-accordion *ngIf="true" class="custom-accordion w-p-100">
  <mat-expansion-panel [expanded]='isExpanded' (opened)="changeExpand(true)"
                       (closed)="changeExpand(false)">
    <mat-expansion-panel-header>
      <mat-panel-title class="flex flex-row justify-between items-start">
        <div style="width:100%">
        </div>
        {{section?.title}}
        <div class="flex flex-row justify-start items-center">
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <particle-flow-chart-designer [section]="section" [sourceType]="sourceType"
                                  [flowChartDataService]="flowChartDataService"></particle-flow-chart-designer>


  </mat-expansion-panel>
</mat-accordion>
